import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { BranchBadge } from './BranchSelector';
import { ROLE_LABELS, PERMISSION_LABELS } from '../utils/permissions';
import { Plus, Edit, Trash2 } from 'lucide-react';

const StaffTabContent = ({ staffList, onAdd, onEdit, onDelete }) => {
  return (
    <>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-semibold text-white">Personel ({staffList.length})</h3>
        <Button size="sm" onClick={onAdd}
          className="bg-brand hover:bg-brand text-xs h-8" data-testid="add-staff-btn">
          <Plus className="h-3 w-3 mr-1" />Personel Ekle
        </Button>
      </div>
      <div className="space-y-2">
        {staffList.map(s => (
          <Card key={s.id} className="bg-gray-800/60 border-gray-700/40" data-testid={`staff-card-${s.id}`}>
            <CardContent className="p-3 flex justify-between items-start">
              <div>
                <div className="flex items-center gap-2">
                  <p className="text-white font-semibold text-sm">{s.name}</p>
                  <Badge className={`text-xs ${s.isActive ? 'bg-green-600' : 'bg-red-600'} text-white`}>
                    {s.isActive ? 'Aktif' : 'Devre Dışı'}
                  </Badge>
                  <Badge className="bg-indigo-600 text-white text-xs">{ROLE_LABELS[s.role] || s.role}</Badge>
                  {s.primaryBranchName && <BranchBadge branchId={s.primaryBranchId} branchName={s.primaryBranchName} small />}
                </div>
                <p className="text-gray-400 text-xs mt-0.5">{s.email} {s.phone ? `| ${s.phone}` : ''}</p>
                {s.accessibleBranchNames?.length > 0 && (
                  <div className="flex gap-1 mt-1">
                    {s.accessibleBranchNames.map((bn, i) => (
                      <span key={`br-${bn}-${i}`} className="text-[10px] text-gray-500 bg-gray-700/50 px-1.5 py-0.5 rounded">{bn}</span>
                    ))}
                  </div>
                )}
                <div className="flex flex-wrap gap-1 mt-1.5">
                  {(s.permissions || []).slice(0, 5).map(p => (
                    <Badge key={p} variant="outline" className="border-gray-600 text-gray-400 text-[10px]">
                      {PERMISSION_LABELS[p] || p}
                    </Badge>
                  ))}
                  {(s.permissions || []).length > 5 && (
                    <Badge variant="outline" className="border-gray-600 text-gray-400 text-[10px]">
                      +{(s.permissions || []).length - 5}
                    </Badge>
                  )}
                </div>
              </div>
              <div className="flex gap-1">
                <Button size="sm" variant="outline" className="border-gray-600 text-gray-300 text-xs h-7"
                  onClick={() => onEdit(s)} data-testid={`edit-staff-${s.id}`}>
                  <Edit className="h-3 w-3" />
                </Button>
                <Button size="sm" variant="outline" className="border-red-800 text-red-400 text-xs h-7 hover:bg-red-900/30"
                  onClick={() => onDelete(s.id)} data-testid={`delete-staff-${s.id}`}>
                  <Trash2 className="h-3 w-3" />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
};

export default StaffTabContent;
